module.exports = __webpack_public_path__ + "img/small_teacher.a4e9949a.png";